export const TIMEFACTOR_PRESETS = [
    '1:1 Pristine Digital Delay [DigitalDelay]',
    '1:2 Airplane Hanger [Multitap]',
    '2:1 Vintage Filtered Echoes [VintageDelay]',
    '2:2 Bridge of Sighs [DigitalDelay]',
    '3:1 Guitars in Space [BandDelay]',
    '3:2 Backwards Riffs [Reverse]',
    '4:1 Volume Swell Helper [DuckedDelay]',
    '4:2 Classic Slap [TapeEcho]',
    '5:1 TwinDelay [DigitalDelay]',
    '5:2 Classic Chorus [VintageDelay]',
    '6:1 Schizo Delay [FilterPong]',
    '6:2 Ethereal Echoes [Reverse]',
    '7:1 Copy Cat [DigitalDelay]',
    '7:2 Every Lead You Fake [ModDelay]',
    '8:1 Where the Avenues Have No Name [VintageDelay]',
    '8:2 Over the Rainbow [BandDelay]',
    '9:1 Lost Lunch [ModDelay]',
    '9:2 Ghost Town [MultiTap]',
    '10:1 Pedal Pitch [ModDelay]',
    '10:2 Dring Modulator [Reverse]',
    '11:1 Reggae Wahdelay Dark [BandDelay]',
    '11:2 Reggae Wahdelay Bright [BandDelay]',
    '12:1 500 Seater [MultiTap]',
    '12:2 Big Swellpad1 [MultiTap]',
    '13:1 MultiTap Hall [MultiTap]',
    '13:2 Ambient MultiTap [MultiTap]',
    '14:1 MultiTap WetLive [MultiTap]',
    '14:2 What Im Looking For [DigitalDelay]',
    '15:1 Galloper MultiTap [DigitalDelay]',
    '15:2 Tapper [MultiTap]',
    '16:1 Springy Verb [FilterPong]',
    '16:2 Strummer [MultiTap]',
    '17:1 Strummer2 [MultiTap]',
    '17:2 King\'s Missile [MultiTap]',
    '18:1 Reverse Flutters [Reverse]',
    '18:2 Time Slips1 [BandDelay]',
    '19:1 Time Slips2 [BandDelay]',
    '19:2 Time Slips3 [BandDelay]',
    '20:1 1.. and 2 [DigitalDelay]',
    '20:2 1.. and 2 Mod [ModDelay]',
    '21:1 Lazyphasy [ModDelay]',
    '21:2 Funk Echo [ModDelay]',
    '22:1 PhaserEcho1 [ModDelay]',
    '22:2 PhaserEcho2 [ModDelay]',
    '23:1 Long Vintage [VintageDelay]',
    '23:2 AutoMarch [MultiTap]',
    '24:1 Reverse Flutters2 [Reverse]',
    '24:2 Pong Echoes [FilterPong]',
    '25:1 Nice Thick Thickener [FilterPong]',
    '25:2 Warped Record [TapeEcho]',
    '26:1 Record Head [TapeEcho]',
    '26:2 Wah Echo1 [BandDelay]',
    '27:1 Long Vintage2 [VintageDelay]',
    '27:2 WubbaWubbaWub [FilterPong]',
    '28:1 Science Museum [FilterPong]',
    '28:2 Reverse Space [Reverse]',
    '29:1 Backwards All [Reverse]',
    '29:2 Reverse Space2 [Reverse]',
    '30:1 Backwards All2 [Reverse]',
    '30:2 Reverse Space3 [Reverse]',
    '31:1 Reverse No Crystals [Reverse]',
    '31:2 Inside Out [Reverse]',
    '32:1 FlutterWow [TapeEcho]',
    '32:2 Big Warm Digital [DigitalDelay]',
    '33:1 Trem Delays [DigitalDelay]',
    '33:2 Dual Big Warm Digital [DigitalDelay]',
    '34:1 Big Nice Day [DigitalDelay]',
    '34:2 Filtered Digital [DigitalDelay]',
    '35:1 ChorusyTrem [DigitalDelay]',
    '35:2 Flaser [DigitalDelay]',
    '36:1 Storm Brewing1 [DigitalDelay]',
    '36:2 Storm Brewing2 [DigitalDelay]',
    '37:1 Haw Echoes1 [BandDelay]',
    '37:2 Haw Echoes2 [BandDelay]',
    '38:1 Phasery Band [BandDelay]',
    '38:2 Phasery Band2 [BandDelay]',
    '39:1 Country Compressor [DuckedDelay]',
    '39:2 Two Vintage Echoes [VintageDelay]',
    '40:1 SlapVintage [VintageDelay]',
    '40:2 Nice Old Echoes [VintageDelay]',
    '41:1 Ambient Vintage [VintageDelay]',
    '41:2 Long Old Delays [VintageDelay]',
    '42:1 Rotten Old Delays [VintageDelay]',
    '42:2 The Lo-Rez trail [VintageDelay]',
    '43:1 Be Wowed [TapeEcho]',
    '43:2 Phasery Banddelay [BandDelay]',
    '44:1 Ramp Up Reverse [Reverse]',
    '44:2 Creepy [ModDelay]',
    '45:1 GooeyFilteropong [FilterPong]',
    '45:2 Chorusphase No Delay [ModDelay]',
    '46:1 Unnatural Room [MultiTap]',
    '46:2 Turnit Back [Reverse]',
    '47:1 Slap Phase [BandDelay]',
    '47:2 Deep Phase Echo [ModDelay]',
    '48:1 And Wobblier [TapeEcho]',
    '48:2 More Reverse Slaps [Reverse]',
    '49:1 Trashcan Flange [DigitalDelay]',
    '49:2 It\'s the 5-0 [VintageDelay]',
    '50:1 The Closer [VintageDelay]',
    '50:2 Filter Echo [BandDelay]',
];
